import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";
import ProductionDashboardStore from "./stores/productiondashboardstore";
import { createContext } from "react";
import { toJS } from "mobx";
import { Skeleton } from "antd";
const _ = require("underscore");
const ProductionDashboardStoreCtx = createContext(ProductionDashboardStore);

const toFiniteNumber = (value) => {
  const number = Number(toJS(value));
  return Number.isFinite(number) ? number : 0;
};

const sumValues = (values) =>
  _.reduce(
    values,
    function (memo, num) {
      return memo + toFiniteNumber(num);
    },
    0
  );

const formatBopd = (value) => Number(toFiniteNumber(value).toFixed(2)).toLocaleString() + "bopd";

export const ProductionBarChart = ({
  showLabel,
  showLegend,
  oilcol,
  gascol,
  nglcol,
  boecol,
}) => {
  const productionDashboardStore = useContext(ProductionDashboardStoreCtx);

  const drillupTitle = () =>
    "Total BOE<br/><span style='color:red'>" +
    formatBopd(
      sumValues(
        [...productionDashboardStore.productions.values()].map((x) => x[boecol])
      )
    );

  const drilldownTitle = (seriesOptions) => {
    return (
      `<span style='color: #FFCC2A'>Total ${seriesOptions.name} BOE</span><br/><span style='color:white'>` +
      formatBopd(sumValues(seriesOptions.data.map((x) => x[1])))
    );
  };
  // Positioning the title

  /* useEffect(() => {
    async function getData() {
      await productionDashboardStore.getDashboardData();
    }
    getData();
  }, []); */

  return (
    <Observer>
      {() =>
        productionDashboardStore.isLoading ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                type: "column",
                events: {
                  drilldown: function (e) {
                    var chart = this;

                    chart.setTitle({
                      text: drilldownTitle(e.seriesOptions),
                    });
                  },
                  drillup: function (e) {
                    var chart = this;

                    chart.setTitle({ text: drillupTitle() });
                  },
                },
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                style: { fontSize: "14px" },
                text: "",
              },

              xAxis: {
                categories: [
                  ...productionDashboardStore.productions.values(),
                ].map((x) => toJS(x.asset)),
                crosshair: true,
                title: {
                  text: "Asset",
                },
              },
              yAxis: {
                min: 0,
                title: {
                  text: "BOE (bopd)",
                },
              },
              legend: {
                enabled: showLegend,
                floating: false,
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
              tooltip: {
                positioner: function (labelWidth, labelHeight, point) {
                  const chart = this.chart;
                  const padding = 8;
                  const pointX = chart.plotLeft + (point?.plotX || 0);
                  const showOnRight = pointX < chart.chartWidth / 2;

                  return {
                    x: showOnRight
                      ? chart.chartWidth - labelWidth - padding
                      : padding,
                    y: chart.plotTop + padding,
                  };
                },
                headerFormat:
                  '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat:
                  '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y:.2f} bopd</b></td></tr>',
                footerFormat: "</table>",
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.2,
                  borderWidth: 0,
                  dataLabels: {
                    enabled: showLabel,
                    formatter: function () {
                      return Number(this.y).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      });
                    },
                    crop: false,
                    overflow: "allow",
                    y: -4,
                  },
                },
              },
              series: [
                {
                  name: "BOE (bopd)",
                  colorByPoint: true,
                  data: [...productionDashboardStore.productions.values()].map(
                    (x) => {
                      return {
                        name: toJS(x.asset),
                        y: toFiniteNumber(x[boecol]),
                        drilldown: toJS(x.asset),
                      };
                    }
                  ),
                  color: "red",
                },
              ],
              drilldown: {
                series: [...productionDashboardStore.productions.values()].map(
                  (x, idx) => {
                    return {
                      name: toJS(x.asset),
                      id: toJS(x.asset),
                      data: [
                        ["Oil", toFiniteNumber(x[oilcol])],
                        ["Gas", toFiniteNumber(x[gascol])],
                        ["Ngl", toFiniteNumber(x[nglcol])],
                      ],
                    };
                  }
                ),
              },

              responsive: {
                rules: [
                  {
                    condition: {
                      maxWidth: 1000,
                    },
                    chartOptions: {
                      legend: {
                        enabled: showLegend,
                        floating: false,
                        layout: "horizontal",
                        align: "center",
                        verticalAlign: "bottom",
                        x: 0,
                        y: 0,
                      },
                      yAxis: [
                        {
                          labels: {
                            align: "right",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          labels: {
                            align: "left",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          visible: false,
                        },
                      ],
                    },
                  },
                ],
              },
            }}
          />
        )
      }
    </Observer>
  );
};

